import {Component, EventEmitter, HostBinding, Input, Output, ViewChild, ViewContainerRef} from '@angular/core';
import {Router} from '@angular/router';
import {Example} from '../../models/example.model';
import {ExampleSJ} from '../../models/example-sj.model';
import {SimpleWord} from '../../models/simple-word.model';
import {LIST_TYPE, RESULT_LINKPOPUP} from '../../defines/client.const';
import {multiLinkMixin} from '../../mixin/multi-link.mixin';
import {WordHistoryService} from '../../services/word/word-history.service';
import {DynamicComponentService} from '../../services/dynamic-component/dynamic-component.service';
import {GlobalEventService} from '../../services/global-event/global-event.service';

@Component({
  selector: 'app-example-detail',
  templateUrl: './example-detail.component.html',
  styleUrls: ['./example-detail.component.scss'],
})
export class ExampleDetailComponent extends multiLinkMixin {
  @HostBinding('class') class = 'page-contents scroll-effect over-y';
  @ViewChild('wordCardContainer1', {read: ViewContainerRef}) wordCardContainer1?: ViewContainerRef;
  @ViewChild('wordCardContainer2', {read: ViewContainerRef}) wordCardContainer2?: ViewContainerRef;
  @Input() example: Example | null = null;
  @Input() exampleSJ: ExampleSJ | null = null;
  @Input() sendingBookmark = false;
  @Output() toggleBookmark = new EventEmitter<MouseEvent>();

  constructor(
    public override router: Router,
    public override wHistorySvc: WordHistoryService,
    public override dynamicSvc: DynamicComponentService,
    private globalEventSvc: GlobalEventService,
  ) {
    super(router, wHistorySvc, dynamicSvc);
  }

  get bookmarkCss(): string {
    if (this.sendingBookmark) return 'ing';
    return this.example?.bookmark ? 'on' : '';
  }

  onToggleBookmark($event: MouseEvent): void {
    this.toggleBookmark.emit($event);
  }

  onClickWordCard($event: MouseEvent, word: SimpleWord, cardNum: number): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event, true);

    const container = cardNum === 1 ? this.wordCardContainer1 : this.wordCardContainer2;
    if (!container) return;

    this.OpenMultiLink(word.id, container, word.word1).subscribe(result => {
      console.log('ExampleDetailComponent::onClickWordCard() result =', result);
    });
  }
}
